import PhraseBook from "@/mandarin/phraseBook";
import { Fragment, useMemo, useState } from "react";

import type { PhraseType, SentenceType, WordType } from "@/mandarin/types";
import { TTSButton } from "@/mandarin/ttsButton";
import { useQuery } from "@tanstack/react-query";
import fetchApi from "@/utils/fetchApi";

const lao = "老";
const shi = "師";
const ni = "你";
const hao = "好";
// Lǎoshī nǐ hǎo

const phraseBook = new PhraseBook();

export default function Translate() {
  const [input, setInput] = useState([lao, shi, ni, hao].join(""));

  // const sentences: SentenceType[] = [
  //   {
  //     phrases: [
  //       {
  //         words: [
  //           { character: lao, pinyin: phraseBook.getPinyinForChar(lao) ?? "?", english: "old" },
  //           {
  //             character: shi,
  //             pinyin: phraseBook.getPinyinForChar(shi) ?? "?",
  //             english: "wise person",
  //           },
  //         ],
  //         meaning: "Teacher",
  //       },
  //       {
  //         words: [
  //           { character: ni, pinyin: phraseBook.getPinyinForChar(ni) ?? "?", english: "you" },
  //           { character: hao, pinyin: phraseBook.getPinyinForChar(hao) ?? "?", english: "good" },
  //         ],
  //         meaning: "Hello",
  //       },
  //     ],
  //     meaning: "Hello Teacher",
  //   },
  // ];

  return (
    <div className="m-auto flex flex-col justify-center p-5">
      <div className="flex">
        <input
          className="border p-1"
          autoFocus
          onChange={(e) => {
            setInput(e.target.value);
          }}
          value={input}
        />
        <TTSButton message={input} />
      </div>
      <SentenceBuilder input={input} />
      {/* <hr /> */}
      {/* Ideally it would show...
      {sentences.map((sentence, i) => (
        <Fragment key={sentence.meaning + i}>
          <div className="text-md">{sentence.meaning}</div>
          <Sentence sentence={sentence} />
        </Fragment>
      ))} */}
    </div>
  );
}

function SentenceBuilder({ input }: { input: string }) {
  const sentences = useMemo(() => phraseBook.parseSentence(input), [input]);
  return (
    <Fragment>
      {sentences.map((sentence) => (
        <Fragment
          key={sentence.phrases
            .map((phrase) => phrase.words.map((word) => word.character).join(""))
            .join("")}
        >
          <div className="text-md">translation...</div>
          <Sentence sentence={sentence} />
        </Fragment>
      ))}
      {/* <code className="font-mono">
        <pre>{JSON.stringify(sentences, null, "\t")}</pre>
      </code> */}
    </Fragment>
  );
}

function Sentence({ sentence }: { sentence: SentenceType }) {
  return (
    <div className="flex flex-col gap-2 p-2">
      <div className="flex gap-2">
        {sentence.phrases.map((phrase, i) => (
          <Phrase key={`${phrase.meaning}_${i}`} phrase={phrase} />
        ))}
      </div>
    </div>
  );
}

function Phrase({ phrase }: { phrase: PhraseType }) {
  const char = phrase.words.map((word) => word.character).join("");
  const { data } = useQuery({
    queryKey: ["GET", "/api/cccedict.php", { query: { char } }],
    queryFn: fetchApi,
    staleTime: Infinity,
  });
  console.log({ data });

  return (
    <div className="flex flex-col gap-2">
      <div className="flex gap-2">
        {phrase.words.map((word, i) => (
          <Word key={`${word.character}_${i}`} word={word} />
        ))}
      </div>
      <English meaning={data?.english_expanded?.at(0) ?? ""} />
    </div>
  );
}

function Word({ word }: { word: WordType }) {
  const char = word.character;
  const { data } = useQuery({
    queryKey: ["GET", "/api/cccedict.php", { query: { char } }],
    queryFn: fetchApi,
    staleTime: Infinity,
  });

  return (
    <div className="align-center flex flex-col justify-center gap-2 border p-2">
      <Pinyin pinyin={data?.pinyin_diacritic ?? ""} />
      <span className="text-center text-4xl subpixel-antialiased">{word.character}</span>
      <English meaning={data?.english_expanded?.at(0) ?? ""} />
    </div>
  );
}

function Pinyin({ pinyin }: { pinyin: string }) {
  return <span className="text-center text-base">{pinyin}</span>;
}

function English({ meaning }: { meaning: string }) {
  return <span className="text-center text-xs/6">{meaning}</span>;
}
